import Marker from '../Marker';

/** Square marker */
export default class SquareMarker extends Marker {
	getDefaultParams() {
		return {
			fillColor: '#CCC'
		};
	}

	render(ctx, data, xScale, yScale,
		{
			beginPath = true,
			color = null,
			fillColor,
			length: height = 4,
			lineWidth = 1
		}
	) {
		const halfHeight = height / 2;

		ctx.save();
		ctx.fillStyle = fillColor;
		ctx.strokeStyle = color;
		ctx.lineWidth = lineWidth;

		if (beginPath) ctx.beginPath();
		for (const row of data) {
			const x0 = xScale(row[0]);
			const y0 = yScale(row[1]);

			ctx.rect(
				x0 + halfHeight, // Draw CCW for clipping offset region
				y0 - halfHeight,
				-height, // Draw CCW for clipping offset region
				height
			);
		}
		if (fillColor) ctx.fill();
		if (color) ctx.stroke();

		ctx.restore();
	}
}
